import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import { css } from "styled-components";

// EC-873 : Fixing overflow scroll issue on approver dropdown
createUserModalStyles.modal = {
    cssOverrides: {
        modalBody: css`
            overflow-y: scroll;
        `,
    },
};
// EC-873 : Fixing overflow scroll issue on approver dropdown
